import { Component, Input } from '@angular/core';

@Component({
  selector: 'abc-badge',
  standalone: true,
  template: `
    <ng-content></ng-content>
    @if (visible && number != null && number !== '') {
      <span class="abc-badge-content">{{ number }}</span>
    }
  `,
  styleUrls: ['./abc-badge.component.scss'],
})
export class AbcBadgeComponent {
  @Input() number: string | number;
  @Input() visible = true;
}
